import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Asset from "./Asset";
import { setloading } from "../../redux/sceneSlice";
import { reduxLocalStorage } from "../utility/storage";

function ExternalWalls() {
  const project_id = reduxLocalStorage.getItem("project_id");
  const dispatch = useDispatch();
  const selectedFloor = useSelector(
    (state) => state.floorVisibility.selectedFloors,
  );
  var targetBuildingScene = useSelector(
    (state) => state.sceneVisibility.value[1],
  );

  var facadeList = useSelector((state) => state.sceneVar.facadeList);
  return (
    <group name="external walls" visible={targetBuildingScene}>
      {facadeList.map((floor, index) => {
        return (
          <React.Fragment key={index}>
            <Asset
              url={`${process.env.REACT_APP_API_URL}project/glb/?project_id=${project_id}&type=${floor}`}
              visible={targetBuildingScene && selectedFloor[index]}
              color={"#defced"}
              onFulfilled={() =>
                dispatch(
                  setloading({ index: 1, subIndex: index, value: false }),
                )
              }
              onLoading={() =>
                dispatch(setloading({ index: 1, subIndex: index, value: true }))
              }
            />
          </React.Fragment>
        );
      })}
    </group>
  );
}

export default React.memo(ExternalWalls);
